import { forwardRef, memo } from "react";
import classnames from "classnames";
import { Tooltip, TooltipProps } from "../../../Tooltip";
import { StepBase } from "../../StepBase";
import { ProgressStepProps } from "../types";
import { getIndicatorState } from "../utils";

import styles from "./style.module.scss";

export type ProgressMinimalIconsConnectedProps = ProgressStepProps & {
  connectorClassName?: string
  tooltipProps?: Omit<TooltipProps, "content" | "supportingContent" | "children">
};

export const ProgressMinimalIconsConnected = memo(
  forwardRef<HTMLDivElement, ProgressMinimalIconsConnectedProps>(
    (
      {
        size = "sm",
        className,
        currentStep = 0,
        tooltipProps,
        connectorClassName,
        ...props
      },
      ref,
    ) => {
      return (
        <div
          className={classnames(styles.root, className)}
          {...props}
          ref={ref}
        >
          {props.steps?.map((item, index) => (
            <div className={styles.container} key={item.id}>
              <Tooltip
                content={item.text}
                supportingContent={item.supportingText}
                {...tooltipProps}
              >
                <StepBase
                  {...item}
                  id={`${item?.id}`}
                  size={size}
                  type={"iconOnly"}
                  status={getIndicatorState(index, currentStep)}
                />
              </Tooltip>
              {index < props.steps.length - 1 && (
                <div className={classnames(styles.connector, connectorClassName, {
                  [styles.connectorComplete]: index < currentStep,
                })}></div>
              )}
            </div>
          ))}
        </div>
      );
    },
  ),
);
